/* import __COLOCATED_TEMPLATE__ from './container.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './container.module.scss';

@classic
@classNames('layout-container', styles.component)
export default class LayoutContainer extends Component {}
